import React from "react";
import { connect } from "react-redux";
import {
  accessVerify,
  onApproveAccessRequest,
  onRejectAccessRequest
} from "../../actions/user";
import { Action } from "../../react-cognito/actions";
import { NotificationManager } from "react-notifications";
import { ProgressBar } from "react-bootstrap";
import { setCookie } from "../../utils/helper";
import history from "../../history.js";
import socket from "../../utils/socket.io";

const $ = window.$;
const initialState = {
  userBlocked: false,
  pending: false,
  timePercentage: 100,
  socket: socket
};
let CountDownTimer;
const mapStateToProps = state => {
  return {
    user: state.cognito.user,
    currentUser: state.userReducer.currentUser,
    currentPetshop: state.petShopReducer.currentPetshop,
    verifyAccessKey: state.userReducer.verifyAccessKey,
    verifyAccessStatus: state.userReducer.verifyAccessStatus,
    verifyAccessError: state.userReducer.verifyAccessError
  };
};
const mapDispatchToProps = dispatch => ({
  verifyLogin: () => dispatch(accessVerify()),
  localLogOut: () => dispatch(Action.logout()),
  onApproveAccessRequest: data => {
    dispatch(onApproveAccessRequest(data));
  },
  onRejectAccessRequest: data => {
    dispatch(onRejectAccessRequest(data));
  }
});

class BlockUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }
  componentWillReceiveProps = (nextProps, prevProps) => {
    if (this.props.verifyAccessStatus !== nextProps.verifyAccessStatus) {
      switch (nextProps.verifyAccessStatus) {
        case "pending":
          this.blockUser();
          NotificationManager.warning("Your request has been sent.");
          break;
        case "approved":
          this.unblockUser();
          NotificationManager.success("Your request approved by admin.");
          break;
        default:
          NotificationManager.error("You have been kicked out.");
          this.logOut();
          break;
      }
    }
    if (this.props.verifyAccessError !== nextProps.verifyAccessError) {
      this.logOut();
      NotificationManager.error("Something went wrong.");
    }
  };
  componentDidMount = () => {
    let user = this.props.currentUser;
    if (user.UserPetstores.length > 0) {
      if (user.UserPetstores[0].Role.role_name.toLowerCase() !== "admin") {
        this.props.verifyLogin();
        this.state.socket.on("access_approved_" + user.user_sub, data => {
          this.props.onApproveAccessRequest(data);
        });
        this.state.socket.on("access_rejected_" + user.user_sub, data => {
          this.props.onRejectAccessRequest(data);
        });
      }
    }
  };
  logOut = event => {
    if (event) event.preventDefault();
    this.state.socket.removeAllListeners();

    this.state.socket.disconnect();
    clearInterval(CountDownTimer);
    if (this.props.user != null) {
      $("#block_user").modal("hide");
      this.props.user.signOut();
      this.props.localLogOut();
      history.replace("/login");
    }
  };
  blockUser = () => {
    this.setState({
      userBlocked: true,
      pending: true
    });
    this.startProgressDown();
    $("#block_user").modal("show");
  };
  unblockUser = () => {
    // debugger
    this.setState({
      userBlocked: false,
      pending: false
    });
    clearInterval(CountDownTimer);
    $("#block_user").modal("hide");
  };
  render = () => {
    return (
      <div
        className="modal fade show"
        id="block_user"
        tabIndex="-1"
        role="dialog"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title">
                  Your admin must approve your login to continue.
                </h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12">
                    Please contact your admin.You will be automatically logout
                    in 5 minutes.
                  </div>
                </div>
                <ProgressBar animated now={this.state.timePercentage} />
              </div>
              <div className="modal-footer">
                <div>
                  <button
                    onClick={event => this.logOut(event)}
                    className="btn btn-primary m-btn--pill"
                  >
                    Log Out
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };
  startProgressDown = () => {
    let startTime = new Date();
    CountDownTimer = setInterval(() => this.countDown(+startTime), 1000);
  };
  countDown = start => {
    const now = new Date();
    const timePercentage = parseInt(((+now - start) * 100) / (5 * 60000));
    if (timePercentage > 100) {
      clearInterval(CountDownTimer);
      this.logOut();
    }
    this.setState({ timePercentage: 100 - timePercentage });
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BlockUser);
